var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81575 1.66134C9.05936 0.254134 12.8426 1.14308 15.1198 3.84783C17.3973 6.55258 17.6286 10.4317 15.6888 13.3881C13.7491 16.3444 10.0988 17.6768 6.71071 16.6647C3.32233 15.6529 1.00063 12.5371 1 9.00101C1 8.76601 1.01003 8.53414 1.0304 8.30477C1.28579 5.38037 3.1224 2.83041 5.81575 1.66134Z",
    stroke: "#DB6443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 3.66602V4.73104",
    stroke: "#DB6443",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8457 12.5107V13.607",
    stroke: "#DB6443",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94971 8.63622C7.75848 8.54688 6.86791 7.62557 6.90502 6.5656C6.94213 5.50564 7.95209 4.71901 9.14333 4.80835C10.3346 4.89769 11.2251 5.819 11.188 6.87896",
    stroke: "#DB6443",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94884 8.63401C10.1401 8.72335 11.0306 9.64466 10.9935 10.7046C10.9564 11.7646 9.94645 12.5512 8.75522 12.4619C7.56398 12.3725 6.67342 11.4512 6.71053 10.3913",
    stroke: "#DB6443",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.517e54b4.svg";
export { ForwardRef as ReactComponent };